import type { Track } from "../types";

export const TRACKS: readonly Track[] = [
  { name: "Monaco", label: "Aero · slow corners", weights: { teamMotor: 0, teamAero: 0.6, driverPace: 0.1, driverConsistency: 0.3 } },
  { name: "Silverstone", label: "Balanced · fast", weights: { teamMotor: 0.25, teamAero: 0.3, driverPace: 0.3, driverConsistency: 0.15 } },
  { name: "Spa", label: "Motor + pace", weights: { teamMotor: 0.4, teamAero: 0.2, driverPace: 0.4, driverConsistency: 0 } },
  { name: "Monza", label: "Pure power", weights: { teamMotor: 0.6, teamAero: 0, driverPace: 0.3, driverConsistency: 0.1 } },
  { name: "Interlagos", label: "Mixed consistency", weights: { teamMotor: 0.15, teamAero: 0.3, driverPace: 0.3, driverConsistency: 0.25 } },
  { name: "Suzuka", label: "Technical · aero", weights: { teamMotor: 0.1, teamAero: 0.45, driverPace: 0.25, driverConsistency: 0.2 } },
  { name: "Montreal", label: "Stop-go · motor", weights: { teamMotor: 0.45, teamAero: 0.15, driverPace: 0.25, driverConsistency: 0.15 } },
  { name: "Hungaroring", label: "Aero · twisty", weights: { teamMotor: 0, teamAero: 0.5, driverPace: 0.2, driverConsistency: 0.3 } },
  { name: "Imola", label: "Old-school · consistency", weights: { teamMotor: 0.2, teamAero: 0.3, driverPace: 0.2, driverConsistency: 0.3 } },
  { name: "Abu Dhabi", label: "Balanced finale", weights: { teamMotor: 0.3, teamAero: 0.3, driverPace: 0.25, driverConsistency: 0.15 } },
  { name: "Jeddah", label: "High-speed street", weights: { teamMotor: 0.35, teamAero: 0.2, driverPace: 0.35, driverConsistency: 0.1 } },
  { name: "Singapore", label: "Street · endurance", weights: { teamMotor: 0.1, teamAero: 0.4, driverPace: 0.15, driverConsistency: 0.35 } },
  { name: "Austin", label: "Balanced · technical", weights: { teamMotor: 0.25, teamAero: 0.3, driverPace: 0.25, driverConsistency: 0.2 } },
  { name: "Bahrain", label: "Stop-go · traction", weights: { teamMotor: 0.4, teamAero: 0.2, driverPace: 0.2, driverConsistency: 0.2 } },
  { name: "Zandvoort", label: "Banked · aero", weights: { teamMotor: 0.15, teamAero: 0.45, driverPace: 0.3, driverConsistency: 0.1 } },
  { name: "Nurburgring", label: "Technical · all-round", weights: { teamMotor: 0.25, teamAero: 0.25, driverPace: 0.25, driverConsistency: 0.25 } },
];

// A championship runs this many Grands Prix, drawn at random from TRACKS.
export const CALENDAR_SIZE = 10;

export const POINTS: readonly number[] = [25, 18, 15, 12, 10, 8, 6, 4, 2, 1];

// Tunable constants
export const LUCK_CHAOS = 0.55; // ± swing on race score with Chaos mode ON (high variance)
export const LUCK_CALM = 0.2; //  ± swing with Chaos mode OFF (skill-dominant)
export const PREM_START = 0.3; // starting premium-pack chance
export const PREM_PITY = 0.15; // chance rise per non-premium roll
export const PREM_REROLL_PENALTY = 0.1; // premium-chance drop per reroll of a normal pack (anti-fishing)
export const PREM_MIN = 0.1;
export const PREM_MAX = 0.9;
export const MYTHIC_STEPS: readonly number[] = [0.3, 0.2, 0.1]; // ceiling after N mythics
export const GRID_RIVALS = 9; // + player = 10 teams = 20 cars

// Weather is rolled fresh per race, independent of track. Remainder (~0.6) is dry.
export const WEATHER_HEAVY = 0.15;
export const WEATHER_LIGHT = 0.25;
